import Operation from "../index.js";

export default {
    //根据班级查询学员
    invokVIPCodeData(id, fn) {
        Operation.Http.post(`/class/invokVIPCodeData?scheduleId=${id}`, null, fn)
    },
    //获取带参数二维码
    getStudentBindQrCode: function(studentId, fun) {
        Operation.Http.get(`/student/getBindQrCode/${studentId}`, null, fun)
    },
    //直播上课打点
    clockIn(params, fn) {
        Operation.Http.post(`/class/clockIn`, params, fn)
    },
}



// WEBPACK FOOTER //
// ./src/request/api/class.js